import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_52: FaireProductEntity = {
  token: "legacy_prod_abbott-52",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3c273af86af31f93613bec5381e751855acac15bd2090b6daa3710a88c750956.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
